export enum StandbyDutyAssignmentStatus {
  Open = 0,
  Reserved = 1,
  Fixed = 2,
  EmployeeChange = 3
}
